// ** Reducers Imports
// import navbar from "./navbar"
// import layout from "./layout"
// import auth from "./authentication"
// import dataTables from "@src/views/tables/data-tables/store"
// import calendar from "@src/views/Calendars/calendar"
//** Used, down below
import persons from "@src/redux/stores/person"
import toValidate from "@src/redux/stores/to-validate"
import users from "@src/redux/stores/user"
import visits from "@src/redux/stores/visit"

const rootReducer = {
  // navbar,
  // layout,
  // auth,
  // dataTables,
  // calendar
  persons,
  toValidate,
  users,
  visits
}

export default rootReducer
